export const registerVuexModule = (rootStore, moduleName, store) => {
  if (!(moduleName in rootStore._modules.root._children)) {
    rootStore.registerModule(moduleName, store)
  }
}
export const formatarRota = rotasSelecionadas => {
  let contents = []
  let rotas
  rotasSelecionadas.forEach((card, index) => {
    contents[index + 1] = card._id
  })
  rotas = Object.assign({}, contents)
  return rotas
}
